module.exports = __webpack_public_path__ + "img/ignis-glx-mentolato.9a60f52b.png";